
import pt from "../../../assets/images/flags/card/pt_br.svg";
import en from "../../../assets/images/flags/card/en_us.svg";
import es from "../../../assets/images/flags/card/es_es.svg";
import pt_eu from "../../../assets/images/flags/card/pt_eu.svg";

export const flags = {
  "Português":pt,
  "Inglês":en,
  "Espanhol":es,
  "Português Europeu":pt_eu,
};